import React, { useEffect, useState,useRef, useCallback } from 'react'
import Countdown from 'react-countdown'
import Footer from '../inc/Footer';
import CarCard from '../inc/CarCard';
import { Link,useParams } from 'react-router-dom';
import axios from "axios";
import "../inc/GlobalVars";
import { ToastContainer, toast } from 'react-toastify';
import parse from 'html-react-parser';
import   submitBid   from "../inc/hooks/submitBid";
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import lgRotate from 'lightgallery/plugins/rotate';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-fullscreen.css';
import 'lightgallery/css/lg-rotate.css';

function VehicleDetails() {
  const {id} = useParams();
  const user_id = localStorage.getItem('userId'); 
  const [vehicleData,setVehicleData] = useState([]);
  const [vehicleImages,setVehicleImages] = useState([]);
  const [auctionListItems, setAuctionListItems] = useState([]);
  const [watchListStatus,setWatchListStatus] = useState("not_added");


  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);



  const lightGallery = useRef(null);
  useEffect(() => {
    ///getVehicleDetails();
    //getAuctionList(); // Fetch auction list immediately when component mounts
    
      fetchImages();
      getVehicleDetails();
    getAuctionList(); // Refresh auction list every 5 seconds
    
  }, []);

  const fetchImages = async () => {
    try {
      const response = await axios.post(global.apiUrl + "/getVehicleDetailsGallery/" + id);
      setImages(response.data.data);
      
    } catch (error) {
      console.error("Error fetching images:", error);
      
    }
  };

  const onInit = useCallback((detail) => {
    if (detail) {
      lightGallery.current = detail.instance;
    }
  }, []);

  const launchGallery = () => {
    lightGallery.current.openGallery(0);
  };






    const userAndVehicleId = {user_id:user_id,vehicle_id:id}
    function getVehicleDetails()
    {
      axios.post(global.apiUrl + "/getVehicleDetails/",JSON.stringify(userAndVehicleId)).then(function (response) {
        const vdata = response.data["data"];
        
        setVehicleData(vdata[0]);
        setWatchListStatus(vehicleData['watchlist_data'] === "yes" ? "added" : "not_added")
       // console.log(vdata);
      });

    }
    
  function getAuctionList() {
    axios.get(global.apiUrl + "/getSimilarVehicles/"+id+"/"+user_id).then(function (response) {
      const auctionData = response.data["data"];
      setAuctionListItems(auctionData);
    });
  }
 


    const addToWatchlist = (vehicleId) => {
      //watchlistId.current.value = vehicleId;
      const watchlist = {user_id:user_id,vehicle_id:vehicleId}
      
      axios.post(global.apiUrl+'/addToWatchList',JSON.stringify(watchlist)).then(function(response)
      {
          let status= response.data['status'];
          if(status == 400)
          {
              alert("Something Went Wrong");
          }
          else
          {
            setWatchListStatus("added");
            toast.success('Added To Watchlist!', {
              position: "top-left",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
          }
    
      }
    
      )
    };
    
    const removeFromWatchlist = (vehicleId) => {
      //watchlistId.current.value = vehicleId;
      const watchlist = {user_id:user_id,vehicle_id:vehicleId}
      
      axios.post(global.apiUrl+'/removeFromWatchList',JSON.stringify(watchlist)).then(function(response)
      {
          let status= response.data['status'];
          if(status == 400)
          {
              alert("Something Went Wrong");
          }
          else
          {
            setWatchListStatus("not_added");
            toast.success('Vehicle Removed From Watchlist', {
              position: "top-left",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
          }
    
      }
    
      )
    };

    const bidId = useRef(null);
    const bidNow = (vehicleId) => {
      bidId.current.value = vehicleId;
    };
    
    const data = { bid_amount:""}
    const [inputData, setInputData] = useState(data);
    
    const handleData = (e) =>
    {
        setInputData({...inputData,[e.target.name]:e.target.value});
    }
    const [res, setRes] = useState('');
    const handleBidding = async(e) => {
    
      e.preventDefault();
      
      const bid_amount = inputData.bid_amount;
      const vehicleId = bidId.current.value; // Get vehicle ID from form
      await submitBid(bid_amount, vehicleId);
      const res = await submitBid(bid_amount, vehicleId);
  setRes(res);
    }
    

      

      const renderer = ({days,hours,minutes,seconds}) => {
        return(
          <div style={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
          <div style={{display:"flex",flexDirection:"column"}}><span className="time fw-bold">{days}</span><span className="text-white">Days</span></div>
          <span></span>
          <div style={{display:"flex",flexDirection:"column"}}><span className="time fw-bold">{hours}</span><span className="text-white">Hours</span></div>
          <span></span>
          <div style={{display:"flex",flexDirection:"column"}}><span className="time fw-bold">{minutes}</span><span className="text-white">Min</span></div>
          <span></span>
          <div style={{display:"flex",flexDirection:"column"}}><span className="time fw-bold">{seconds}</span><span className="text-white">Sec</span></div>
          
      </div>
        )
    }
  return (
    <div>
       <ToastContainer
position="top-left"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
/>
    <div className='container'>
          <div className='row'>
          <div className="col-md-12 mb-5  pt-5">
          <h1>Vehicle Details </h1>
          </div>
          </div>
      </div>
  <div className='container auction-list-sidebar mb-5'>
      <div className='row d-flex justify-content-center align-items-top'>
          <div className='col-md-3 position-relative'>
          <span className={vehicleData['bid_win_status'] == "no" ? "text-white bid-status-loosing" : "text-white bid-status-win"} style={{fontWeight:"bold"}}>{vehicleData['bid_win_status'] == "no" ? "Loosing" : "Winning"}</span>

          <Link onClick={(e)=>{e.preventDefault();launchGallery();}} className='text-decoration-none'>
            <img src={global.apiUrl +"/"+vehicleData['featured_image']} className='img-fluid carCarImage' />
            </Link>
              {
              watchListStatus === "added" || vehicleData['watchlist_data'] === "yes" ? 
              (
                <button className="btn btn-watchlist" onClick={() => removeFromWatchlist(vehicleData['vehicle_id'])}>Remove From WatchList</button>
              )
              :
              (
                <button className="btn btn-watchlist" onClick={() => addToWatchlist(vehicleData['vehicle_id'])}>Add To WatchList</button>

              )

            }
            
          </div>

          <div className='col-md-6'>
          <div className='carCard'>
          <h3 style={{textTransform:"capitalize"}}>{vehicleData['make_name']+" "+vehicleData['model']+" "+vehicleData['variant']+" ("+vehicleData['manufacture_year']+")"}</h3>
          <ul className="list-group">
          <li className="list-group-item  d-flex justify-content-between align-items-center">
              <div>
              <span className="">Registration Number: &nbsp;</span>
              <span className="fw-bold" style={{textTransform:"uppercase"}}>{vehicleData['reg_number']}</span>
              </div>

              <div>
              <span className="">RC Available: &nbsp;</span>
              <span className={vehicleData['rc_availability'] == 1 ? "text-success fw-bold" : "text-danger fw-bold"}>{vehicleData['rc_availability'] == 1 ? "Yes" : "No"}</span>
              </div>
            </li>
           
            <li className="list-group-item  d-flex justify-content-between align-items-center">
              <div>
              <span className="">Ownership: &nbsp;</span>
              <span className="fw-bold">{vehicleData['ownership']}</span>
              </div>

              <div>
              <span className="">Fuel Type: &nbsp;</span>
              <span className="fw-bold" style={{textTransform:"capitalize"}}>{vehicleData['fuel_type']}</span>
              </div>
            </li>
           
            <li className="list-group-item  d-flex justify-content-between align-items-center">
              <div>
              <span className="">Damage Type: &nbsp;</span>
              <span className="fw-bold" style={{textTransform:"capitalize"}}>{vehicleData['case_name']}</span>
              </div>

              <div>

              <span className="">Transmission: &nbsp;</span>
              <span className="fw-bold" style={{textTransform:"capitalize"}}>{vehicleData['transmission']}</span>
              </div>
            </li>
            
            
            <li className="list-group-item  d-flex justify-content-between align-items-center">
              <span className="">Location</span>
              <span className="fw-bold" style={{textTransform:"capitalize"}}>{vehicleData['location']}</span>
            </li>
            
          </ul>
              <button type="button" onClick={() => bidNow(vehicleData['vehicle_id'])} value={vehicleData['vehicle_id']} data-bs-toggle="modal" data-bs-target={"#exampleModal"+ vehicleData['vehicle_id']} className='btn btn-primary carCardButton'>Bid Now</button>
              <div className='carCardCounter text-center'>
                  <Countdown date={vehicleData['expiry_date']+"T"+vehicleData['expiry_time']} renderer={renderer} />
              </div>
              </div>
          </div>

          <div className='col-md-3'>
          <h5>Bidding Information</h5>
          <ul className="list-group">
          <li className="list-group-item  d-flex justify-content-between align-items-center">
              <span className="">Last Bid</span>
              <span className="fw-bold" style={{textTransform:"capitalize"}}>&#8377;{vehicleData['bid_amount_max'] == null ? "0" : vehicleData['bid_amount_max']}</span>
            </li>
          
            <li className="list-group-item  d-flex justify-content-between align-items-center">
              <div><span className="">Contact Details:</span></div>
              <div>
              
              <span className="ps-1 fw-bold">{vehicleData['name']+" "+vehicleData['contact_mobile']}</span>
              </div>
            </li>
            <li className='list-group-item  '>
            <h5>Note:</h5>
          <div dangerouslySetInnerHTML={{__html: vehicleData['notes']}}></div>
            </li>
          </ul>
      </div>
      </div>
      <div className="modal fade" id={"exampleModal"+vehicleData['vehicle_id']} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content" style={{background:"#edfbfb"}}>
      <div className="modal-header p-0 m-0" >
        
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" style={{position: "absolute",
    right: "-7px",
    color: "#fff",
    top: "-4px",
    filter: "invert(1)"}}></button>
      </div>
      <div className="modal-body">
      {vehicleData['can_bid'] == "yes" ? ( <>
        <form method="POST" encType="multipart/form-data">
          <input type="hidden" name="user_id" value={user_id} />
          <input type="hidden" name="vehicle_id" ref={bidId} />
          <h3 style={{textTransform:"capitalize",textAlign:"center"}}>Place Your Bid</h3>
            <ul className="list-group">
            <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="text-start">BID Status</span>
                <span className={vehicleData['bid_win_status'] == "no" ? "text-white bid-status-loosing" : "text-white bid-status-win"} style={{fontWeight:"bold"}}>{vehicleData['bid_win_status'] == "no" ? "Loosing" : "Winning"}</span>

              </li>
              <li className="list-group-item  d-flex justify-content-between align-items-center">
                <span className="text-start">BID Amount</span>
                <span className="fw-bold">&#8377; {vehicleData['bid_amount_max'] == null ? "0" : vehicleData['bid_amount_max']}</span>
              </li>
            </ul>
          <div className="mb-2 mt-3 input-wrapper">
            <label>Bid Amount <span className="text-danger">*</span></label>
            <input type="text" className="form-control"  value={inputData.bid_amount} onChange={handleData} placeholder="Enter Bid Amount" name="bid_amount" required />
          </div>
          <div className="mt-3">
            <button type="submit" onClick={handleBidding} className="btn btn-primary carCardButton" >Submit Now</button>
          </div>
          {res != null ? (
                  <div className="text-center mt-2" style={{padding:"4px 5px",borderRadius:"5px"}}>
                <h4 className="text-danger text-danger" >{res}</h4>
                </div>
                ) : ''}
          </form>
          </>): (
                  <>
                  <input type="hidden" name="user_id" value={user_id} />
                  <input type="hidden" name="vehicle_id" ref={bidId} />
                  <h3 style={{textTransform:"capitalize",textAlign:"center"}}>Place Your Bid</h3>
                  <p className="text-center text-danger"><b>You are restricted to place bid on this vehicle</b></p>
                </>
                )}
      </div>
      
    </div>
  </div>
</div>

      

     

      <div className='row mt-3'>
          <div className='col-md-12'>
          <h5>Remarks</h5>
          <p>Please inspect the vehicle PHYSICALLY to gauge the exact Degree Of Damage & carefully read the above details before submitting your bid. No bid cancellation or amount revision requests will be entertained once auction expires. It is a post approval auction and your quote shall be valid for 30 days. IndusSalvage will not be responsible for any MISSING Stepney, Battery, Tool Kit & removal of any Extra Accessories fitted by insured at the time of vehicle lifting.</p>

          </div>
      </div>

      <div class="row">

              <div className="col-12 d-flex justify-content-between">
              <h2>Similar Products</h2><span style={{borderTop:'1px solid #dee2e6 !important'}}></span><Link to={"/Auctions"}>View All</Link>
              </div>
          </div>
          <div className="row">
          {auctionListItems.slice(0,4).map((ac, key) => (
              <CarCard
                key={key}
                reg_number={ac.reg_number}
                case_name={ac.case_name}
                insurer_name={ac.insurer_name}
                make_name={ac.make_name}
                model={ac.model}
                expiry_date={ac.expiry_date}
                expiry_time={ac.expiry_time}
                featured_image={ac.featured_image}
                min_bid={ac.min_price}
                vehicle_id={ac.vehicle_id}
                rc_available={ac.rc_availability}
                owners={ac.ownership}
                location={ac.state}
                variant = {ac.variant}
                year={ac.manufacture_year}
                transmission = {ac.transmission}
                cname = {ac.name}
                cmobile = {ac.mobile}
                bid_max_amount = {ac.bid_amount_max}
                bid_win_status = {ac.bid_win_status}
                
              />
            ))}
              
          </div>

      
  </div>
  <Footer/>
  <LightGallery
        onInit={onInit}
        elementClassNames={'gallery'}
        dynamic={true}
        plugins={[lgZoom, lgVideo, lgRotate]}
        dynamicEl={images.map(image => ({
          src: image.src
         
        }))}
      />
  </div>
  )
}

export default VehicleDetails